/* AMRAM DESIGN: theme runtime. No libraries. */
(() => {
  const T = window.AD || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const html = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // motion is off when the OS asks for it or when the accessibility toolbar stopped animations
  const still = () => reduce || document.documentElement.classList.contains('a11y-still');
  const js = (u) => u.replace(/\/?$/, '.js').replace('.js.js', '.js');
  const money = (c) => '₪' + Math.round((c || 0) / 100).toLocaleString('en-US');

  /* ---------- header height → CSS var (sticky offsets) ---------- */
  const setHdr = () => { const h = $('.hdr-sec'); if (!h) return; html.style.setProperty('--hdr-h', h.offsetHeight + 'px'); const a = $('.ann-sec'); html.style.setProperty('--top-h', h.offsetHeight + (a ? a.offsetHeight : 0) + 'px'); };

  /* ---------- drawers: menu / cart / search ---------- */
  let openName = null, lastFocus = null;
  const scrim = () => $('[data-scrim]');
  const drawer = (n) => $(`[data-drawer="${n}"]`);
  function open(name) {
    if (openName && openName !== name) close(true);
    const d = drawer(name); if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    html.classList.add('html-lock');
    $$(`[data-open="${name}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
    if (name !== 'search') { const s = scrim(); if (s) { s.hidden = false; requestAnimationFrame(() => s.classList.add('is-on')); } }
    openName = name;
    setTimeout(() => { const f = name === 'search' ? $('[data-search-input]', d) : $('[data-close]', d); f && f.focus({ preventScroll: true }); }, 80);
    return true;
  }
  function close(silent) {
    if (!openName) return;
    const d = drawer(openName);
    d && d.classList.remove('is-open');
    $$(`[data-open="${openName}"]`).forEach(b => b.setAttribute('aria-expanded', 'false'));
    const s = scrim(); if (s) { s.classList.remove('is-on'); setTimeout(() => { if (!s.classList.contains('is-on')) s.hidden = true; }, 360); }
    html.classList.remove('html-lock');
    openName = null;
    if (!silent && lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) { if (open(o.dataset.open)) e.preventDefault(); return; }
    if (e.target.closest('[data-close]') || e.target.closest('[data-scrim]')) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { close(); closeVideo(); closeZoom(); }
    if (e.key === 'Tab' && openName) {
      const d = drawer(openName);
      const f = $$('a[href],button:not([disabled]),input,select,textarea,summary,[tabindex]:not([tabindex="-1"])', d).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- reveal (scroll position check as a fallback: IO misses what you jump past) ---------- */
  function reveal(root = document) {
    const els = $$('[data-reveal]:not(.is-in)', root);
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(el => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((ents) => ents.forEach(en => {
      if (en.isIntersecting || en.boundingClientRect.top < 0) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    els.forEach(el => io.observe(el));
  }
  addEventListener('scroll', () => { $$('[data-reveal]:not(.is-in)').forEach(el => { if (el.getBoundingClientRect().top < innerHeight * .94) el.classList.add('is-in'); }); }, { passive: true });

  function toast(msg) {
    let t = $('.toast'); if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-on'), 2600);
  }

  /* ---------- hero video: wide on desktop, tall on phones ---------- */
  function heroVideo() {
    const v = $('[data-hero-video]'); if (!v) return;
    const src = matchMedia('(max-width: 749px)').matches ? v.dataset.tall : v.dataset.wide;
    if (v.getAttribute('src') !== src) { v.src = src; v.load(); }
    if (still()) { v.removeAttribute('autoplay'); v.pause(); } else v.play().catch(() => {});
  }

  /* ---------- reels: muted preview on hover, full video with sound in a modal ---------- */
  document.addEventListener('pointerover', (e) => {
    const r = e.target.closest('[data-reel]'); if (!r || still() || e.pointerType === 'touch') return;
    const v = $('video', r); if (!v) return;
    if (!v.src) v.src = v.dataset.src;
    v.play().catch(() => {});
    r.addEventListener('pointerleave', () => { v.pause(); }, { once: true });
  });
  const vm = () => $('[data-vmodal]');
  function playVideo(src) {
    const m = vm(); if (!m) return;
    const v = $('video', m); v.src = src; m.hidden = false; html.classList.add('html-lock');
    v.muted = false; v.play().catch(() => {}); $('[data-vclose]', m).focus();
  }
  function closeVideo() { const m = vm(); if (!m || m.hidden) return; const v = $('video', m); v.pause(); v.removeAttribute('src'); v.load(); m.hidden = true; html.classList.remove('html-lock'); }
  document.addEventListener('click', (e) => {
    const r = e.target.closest('[data-reel]'); if (r) { e.preventDefault(); playVideo(r.dataset.reel); return; }
    if (e.target.closest('[data-vclose]') || e.target.matches('[data-vmodal]')) closeVideo();
    const nav = e.target.closest('[data-rprev],[data-rnext]');
    if (nav) {
      const t = $('[data-reel-track]', nav.closest('[data-reels]') || document); if (!t) return;
      const step = t.firstElementChild ? t.firstElementChild.getBoundingClientRect().width + 6 : 300;
      // RTL: "next" moves toward the left (negative scrollLeft)
      t.scrollBy({ left: nav.matches('[data-rnext]') ? -step : step, behavior: still() ? 'auto' : 'smooth' });
    }
  });

  /* ---------- quote tabs ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qtabs] [role=tab]'); if (!b) return;
    const root = b.closest('[data-qtabs]');
    $$('[role=tab]', root).forEach(t => t.setAttribute('aria-selected', t === b ? 'true' : 'false'));
    $$('[role=tabpanel]', root).forEach(p => p.hidden = p.id !== b.getAttribute('aria-controls'));
  });
  function autoTabs() {
    $$('[data-qtabs]').forEach(root => {
      let i = 0; const tabs = $$('[role=tab]', root); if (tabs.length < 2) return;
      let paused = false; root.addEventListener('pointerenter', () => paused = true); root.addEventListener('pointerleave', () => paused = false);
      setInterval(() => { if (paused || document.hidden || still()) return; i = (i + 1) % tabs.length; tabs[i].click(); }, 6500);
    });
  }

  /* ---------- cart ---------- */
  async function renderCart(sections) {
    let str = sections && sections['cart-drawer'];
    if (!str) { const r = await fetch(`${(T.root || '/').replace(/\/$/, '')}/?sections=cart-drawer`); str = (await r.json())['cart-drawer']; }
    const doc = new DOMParser().parseFromString(str, 'text/html');
    const fresh = $('[data-drawer="cart"]', doc), cur = drawer('cart');
    if (fresh && cur) {
      cur.innerHTML = fresh.innerHTML;
      const n = +fresh.dataset.count || 0;
      $$('[data-cart-count]').forEach(el => { el.textContent = n || ''; el.dataset.n = n; });
      $$('[data-cart-icon]').forEach(el => el.setAttribute('aria-label', `סל הקניות, ${n} פריטים`));
      if (window.ADa11y) window.ADa11y.apply();
    }
  }
  async function addToCart(fd, btn) {
    btn && btn.classList.add('is-loading');
    try {
      fd.append('sections', 'cart-drawer');
      const r = await fetch(js(T.cartAdd || '/cart/add'), { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'משהו השתבש, נסו שוב');
      await renderCart(j.sections);
      open('cart');
      return true;
    } catch (err) {
      const box = btn && btn.closest('form') && $('[data-form-error]', btn.closest('form'));
      if (box) { box.textContent = err.message; box.hidden = false; } else toast(err.message);
      return false;
    } finally { btn && btn.classList.remove('is-loading'); }
  }
  async function changeLine(line, quantity) {
    const d = drawer('cart'); d && d.classList.add('is-busy');
    try {
      const r = await fetch(js(T.cartChange || '/cart/change'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +line, quantity: Math.max(0, +quantity), sections: 'cart-drawer' }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message);
      await renderCart(j.sections);
      if (location.pathname.replace(/\/$/, '').endsWith('/cart')) location.reload();
    } catch (err) { toast(err.message || 'משהו השתבש'); }
    finally { d && d.classList.remove('is-busy'); }
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-qty][data-line]');
    if (q) { e.preventDefault(); changeLine(q.dataset.line, q.dataset.qty); }
  });
  document.addEventListener('change', (e) => {
    const inp = e.target; if (!inp.matches('.cline .qty input[data-line]')) return;
    changeLine(inp.dataset.line, inp.value);
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-product-form]'); if (!f) return;
    e.preventDefault();
    const err = $('[data-form-error]', f); if (err) err.hidden = true;
    const fd = new FormData(f);
    const atc = $('[data-atc]', f);
    // warranty extension: if a paid "warranty" product is set, add it alongside the item
    const w = $('[data-warranty]', f), ext = w && $('[data-warranty-ext]:checked', w);
    (async () => {
      const ok = await addToCart(fd, atc);
      if (ok && ext && w.dataset.variant) {
        const wf = new FormData();
        wf.append('id', w.dataset.variant); wf.append('quantity', fd.get('quantity') || '1');
        wf.append('properties[עבור]', (document.querySelector('.pinfo__t') || {}).textContent || '');
        await addToCart(wf, null);
      }
    })();
  });
  // "לתנאי האחריות" opens the warranty accordion
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-open-acc]'); if (!b) return;
    const d = document.querySelector(`[data-acc="${b.dataset.openAcc}"]`); if (!d) return;
    d.open = true; d.scrollIntoView({ block: 'center', behavior: still() ? 'auto' : 'smooth' });
  });

  /* ---------- qty steppers on the product page ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-step]'); if (!b) return;
    const inp = $('input[type="number"]', b.parentElement); if (!inp) return;
    inp.value = Math.min(99, Math.max(1, (+inp.value || 1) + +b.dataset.step));
  });

  /* ---------- predictive search ---------- */
  let sTimer, sCtrl;
  async function predictive(q) {
    const out = $('[data-search-results]'), idle = $('[data-search-idle]');
    if (!out) return;
    if (!q.trim()) { out.innerHTML = ''; idle && (idle.hidden = false); return; }
    sCtrl && sCtrl.abort(); sCtrl = new AbortController();
    const qs = `?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`;
    try {
      let r = await fetch((T.search || '/search/suggest') + qs, { signal: sCtrl.signal });
      if (!r.ok) r = await fetch('/en/search/suggest' + qs, { signal: sCtrl.signal }); // Hebrew buyer locale can answer 417 here
      if (!r.ok) return;
      const t = (await r.text()).replace(/href="\/en\//g, 'href="/');
      const doc = new DOMParser().parseFromString(t, 'text/html');
      const sec = doc.querySelector('.shopify-section') || doc.body;
      out.innerHTML = sec.innerHTML; idle && (idle.hidden = true); reveal(out);
    } catch (_) { /* aborted */ }
  }
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-search-input]')) return;
    clearTimeout(sTimer); sTimer = setTimeout(() => predictive(e.target.value), 220);
  });

  /* ---------- product page ---------- */
  let zoomEl;
  function closeZoom() { if (zoomEl && !zoomEl.hidden) { zoomEl.hidden = true; html.classList.remove('html-lock'); } }
  function pdp() {
    const root = $('[data-pdp]'); if (!root) return;
    const data = JSON.parse($('[data-variants]')?.textContent || '[]');
    const form = $('[data-product-form]', root);
    const idInput = form && $('[name="id"]', form);
    const main = $('[data-gal]', root);
    const thumbs = $$('[data-gal-thumbs] button', root);
    const count = $('[data-gal-count]', root);
    const slides = main ? [...main.children] : [];
    const go = (i) => { if (!main || !slides[i]) return; main.scrollTo({ left: -i * main.clientWidth * (getComputedStyle(main).direction === 'rtl' ? 1 : -1), behavior: still() ? 'auto' : 'smooth' }); setOn(i); };
    const setOn = (i) => { thumbs.forEach((t, k) => t.classList.toggle('on', k === i)); if (count) count.textContent = `${i + 1} / ${slides.length}`; main && (main.dataset.i = i); };
    if (main) {
      main.addEventListener('scroll', () => setOn(Math.round(Math.abs(main.scrollLeft) / main.clientWidth)), { passive: true });
      thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
      $('[data-gal-prev]', root)?.addEventListener('click', () => go(Math.max(0, (+main.dataset.i || 0) - 1)));
      $('[data-gal-next]', root)?.addEventListener('click', () => go(Math.min(slides.length - 1, (+main.dataset.i || 0) + 1)));
      setOn(0);
      // zoom
      zoomEl = $('[data-zoom]');
      main.addEventListener('click', (e) => {
        const img = e.target.closest('.gal__slide img'); if (!img || !zoomEl) return;
        const zi = $('img', zoomEl); zi.src = img.dataset.full || img.src; zi.alt = img.alt || ''; zoomEl.hidden = false; html.classList.add('html-lock');
      });
      zoomEl && zoomEl.addEventListener('click', closeZoom);
    }
    // options → variant
    const fieldsets = $$('[data-opt]', root);
    const current = () => fieldsets.map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
    function update(fromUser) {
      const sel = current();
      const v = data.find(v => v.options.every((o, i) => o === sel[i]));
      fieldsets.forEach((fs, idx) => {
        const lbl = $('[data-opt-value]', fs); if (lbl) lbl.textContent = sel[idx] || '';
        // mark values with no available variant given the other selections
        $$('input[type=radio]', fs).forEach(inp => {
          const test = sel.slice(); test[idx] = inp.value;
          const ok = data.some(v => v.available && v.options.every((o, i) => o === test[i]));
          inp.closest('label').classList.toggle('is-na', !ok);
        });
      });
      const atc = $('[data-atc]', root), sticky = $('[data-sticky-atc]');
      if (!v) { if (atc) { atc.disabled = true; atc.textContent = 'השילוב הזה לא זמין'; } return; }
      if (idInput) idInput.value = v.id;
      $$('[data-price]').forEach(p => p.textContent = money(v.price));
      $$('[data-compare]').forEach(p => { p.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; p.hidden = !(v.compare_at_price > v.price); });
      $$('[data-off]').forEach(p => { const off = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0; p.textContent = off ? `${off}% הנחה` : ''; p.hidden = !off; });
      [atc, sticky].forEach(b => { if (!b) return; b.disabled = !v.available; b.textContent = v.available ? b.dataset.txt : 'אזל זמנית'; });
      if (fromUser && v.featured_media && main) { const k = slides.findIndex(s => +s.dataset.media === v.featured_media); if (k > -1) go(k); }
      if (fromUser) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    }
    root.addEventListener('change', (e) => { if (e.target.closest('[data-opt]')) update(true); });
    // length slider → the matching hidden radio
    $$('[data-range] input', root).forEach(r => r.addEventListener('input', () => {
      const inp = $$('input[type=radio]', r.closest('[data-opt]'))[+r.value];
      if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    }));
    if (fieldsets.length) update(false);
    // chaise length (Coral 4.11): a slider in 10 cm steps that feeds a line-item property, not a variant
    $$('[data-chaise-range]', root).forEach(r => {
      const fs = r.closest('[data-extra]'), set = () => { const v = (1.7 + r.value / 10).toFixed(2) + ' מ׳'; $('input[type=hidden]', fs).value = v; $('[data-opt-value]', fs).textContent = v; };
      r.addEventListener('input', set); set();
    });
    // WhatsApp question with the chosen configuration
    $$('[data-wa-ask]').forEach(el => el.addEventListener('click', (e) => {
      const num = (T.wa || '').replace(/\D/g, ''); if (!num) return;
      e.preventDefault();
      const lines = [`היי, אשמח לפרטים על ${e.currentTarget.dataset.title}`];
      fieldsets.forEach(fs => { const c = $('input:checked', fs); if (c) lines.push(`${fs.dataset.name}: ${c.value}`); });
      $$('[data-extra]', root).forEach(fs => { const c = $('input[type=hidden],input:checked', fs); if (c) lines.push(`${fs.dataset.name}: ${c.value}`); });
      lines.push(location.href.split('?')[0]);
      window.open(`https://wa.me/${num}?text=${encodeURIComponent(lines.join('\n'))}`, '_blank', 'noopener');
    }));
    // sticky buy bar (scroll check, not IO: IO misses jumps)
    const atc = $('[data-atc]', root) || $('.buy--req .btn', root), sticky = $('[data-sticky]');
    if (atc && sticky) {
      const check = () => { const r = atc.getBoundingClientRect(); const on = r.bottom < 0; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); };
      addEventListener('scroll', () => requestAnimationFrame(check), { passive: true }); check();
      $('[data-sticky-atc]', sticky)?.addEventListener('click', () => { atc.scrollIntoView({ block: 'center', behavior: still() ? 'auto' : 'smooth' }); setTimeout(() => atc.click(), 450); });
    }
    const reco = $('[data-reco]');
    if (reco && !reco.children.length) {
      fetch(reco.dataset.url).then(r => r.text()).then(t => {
        const doc = new DOMParser().parseFromString(t, 'text/html');
        const s = $('[data-reco]', doc);
        if (s && s.innerHTML.trim()) { reco.innerHTML = s.innerHTML; reveal(reco); } else reco.closest('section')?.remove();
      }).catch(() => {});
    }
  }

  /* ---------- collection sort / filters ---------- */
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-sort]')) {
      const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u.toString();
    }
    if (e.target.closest('[data-filters]') && e.target.matches('input[type=checkbox]')) e.target.form.submit();
  });

  /* ---------- boot ---------- */
  // drawers inside sticky section wrappers get their own stacking context: hoist them to <body>
  function hoist(root = document) {
    $$('[data-drawer]', root).forEach(d => {
      if (d.parentElement === document.body) return;
      const old = $('body > [data-drawer="' + d.dataset.drawer + '"]');
      if (old && old !== d) old.remove();
      document.body.appendChild(d);
    });
  }
  document.addEventListener('DOMContentLoaded', () => {
    hoist(); setHdr(); reveal(); heroVideo(); pdp(); autoTabs();
    addEventListener('resize', () => { setHdr(); heroVideo(); });
    document.addEventListener('shopify:section:load', (e) => { hoist(e.target); setHdr(); $$('[data-reveal]', e.target).forEach(el => el.classList.add('is-in')); heroVideo(); });
  });
  // hero slider: fade every 6.5s, pauses on hover/focus or a hidden tab, dots jump
  $$('[data-hs]').forEach(hs => {
    const slides = $$('[data-hs-slide]', hs), dots = $$('[data-hs-dot]', hs);
    if (slides.length < 2) return;
    let i = 0, t = null;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('is-on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach((d, k) => { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      const d = dots[i] && dots[i].querySelector('i'); if (d) { d.style.animation = 'none'; void d.offsetWidth; d.style.animation = ''; }
    };
    const run = () => { clearInterval(t); if (!still()) t = setInterval(() => show(i + 1), 6500); };
    dots.forEach((d, k) => d.addEventListener('click', () => { show(k); run(); }));
    hs.addEventListener('mouseenter', () => clearInterval(t)); hs.addEventListener('mouseleave', run);
    hs.addEventListener('focusin', () => clearInterval(t)); hs.addEventListener('focusout', run);
    document.addEventListener('visibilitychange', () => document.hidden ? clearInterval(t) : run());
    document.addEventListener('ad:still', () => { clearInterval(t); run(); });
    let x0 = null; hs.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    hs.addEventListener('touchend', e => { if (x0 == null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { show(i + (dx > 0 ? 1 : -1)); run(); } x0 = null; });
    run();
  });
  window.ADrt = { open, close, toast, addToCart };
})();
